import { useTranslation } from "react-i18next";
import { UserRole } from "@/types/users";
import type { ITagProps } from "@/ui-kit";
import { Tag } from "@/ui-kit";

type IProps = {
  value: UserRole | null | undefined;
  tagProps?: Partial<ITagProps>;
};

export const useRoleTagMap = () => {
  const { t } = useTranslation();

  const tagPropsMap: Record<UserRole, ITagProps> = {
    [UserRole.Client]: {
      color: "info",
      text: t("label.client"),
    },
    [UserRole.Inspector]: {
      color: "danger",
      text: t("label.inspector"),
    },
    [UserRole.Contractor]: {
      color: "orange",
      text: t("label.contractor"),
    },
    [UserRole.LoanOfficer]: {
      color: "green",
      text: t("label.loan_officer"),
    },
    [UserRole.LoanProcessor]: {
      color: "green",
      text: t("label.loan_processor"),
    },
    [UserRole.ProjectManager]: {
      color: "rose",
      text: t("label.project_manager"),
    },
    [UserRole.Admin]: {
      color: "purple",
      text: t("label.admin"),
    },
    [UserRole.SuperAdmin]: {
      color: "cyan",
      text: t("label.super_admin"),
    },
  };

  const getTagProps = (role: UserRole): ITagProps => {
    return tagPropsMap[role] || {};
  };

  return { tagPropsMap, getTagProps };
};

export const UserRoleTag = ({ value, tagProps: _tagProps }: IProps) => {
  const { tagPropsMap } = useRoleTagMap();

  if (!value) {
    return "";
  }

  const tagProps = {
    ...tagPropsMap[value],
    ..._tagProps,
  };

  return tagPropsMap[value] ? <Tag {...tagProps} /> : <Tag text={value} />;
};
